import { Link } from 'react-router-dom';
import AnimatedSeparator from '../components/AnimatedSeparator';

export default function NurseryPage() {
    // ── Info / landing section ──

    return (
        <div className="page-container">
            <div className="container">

                <div className="row page-hero align-items-end">
                    <div className="col-md-7">
                        <h1>The Nursery</h1>
                        <h2>growing startups from ideas on a napkin.</h2>
                    </div>
                </div>

                <AnimatedSeparator color="#000" />

                {/* How it works */}
                <div className="row">
                    <div className="col-md-3">
                        <h3>Done-For-You startups</h3>
                    </div>
                    <div className="col-md-8 offset-md-1">
                        <ul className="custom-bullets-2">
                            <li>
                                <span>Planning</span>
                                <p>
                                    Nurturing the idea into a development plan, a Go-To-Market strategy, and financial projections to Break-Even.
                                </p>
                            </li>
                            <li>
                                <span>Execution</span>
                                <p>
                                    Securing funding, finding and managing skilled talents, ensuring proper legal framework.
                                </p>
                            </li>
                            <li>
                                <span>Profits</span>
                                <p>
                                    Reaching profitability within a year, with a fully established business, ready to scale & grow.
                                </p>
                            </li>
                        </ul>

                        <p>
                            Graduates of The Nursery pledge 2% of their profits to The Nursery Fund,
                            as support for the next wave of successful foundresses.
                        </p>

                        <Link to="/submit-idea" className="btn-primary">Submit your idea</Link>
                    </div>
                </div>

                <AnimatedSeparator color="#f52e72" />

                {/* Sumbit your idea */}
                <div className="row">
                    <div className="col-md-3">
                        <h3>Join the Nursery</h3>
                    </div>
                    <div className="col-md-8 offset-md-1">
                        <ul className="custom-bullets">
                            <li>
                                <span>Submit your idea on-a-napkin</span>
                                <p>
                                    Fill in a short questionnaire about your idea. Takes about 20 minutes.
                                    Your answers are saved as you go.
                                </p>
                            </li>
                            <li>
                                <span>Review your answers, then pay</span>
                                <p>
                                    Before anything is submitted, you see exactly what you wrote. Edit freely.
                                    When you're ready, a one-time €42 fee secures your submission.
                                </p>
                            </li>
                            <li>
                                <span>Get honest, detailed feedback</span>
                                <p>
                                    Within 5 business days, Ela reviews your submission personally and sends
                                    you written feedback. Selected ideas get full funding for a done-for-you build.
                                </p>
                            </li>
                        </ul>

                        <Link to="/submit-idea" className="btn-secondary">Submit your idea</Link>
                    </div>
                </div>

                <AnimatedSeparator color="#000" />

                {/* Who this is for */}
                <div className="row">
                    <div className="col-md-3">
                        <h3>Who this is for</h3>
                    </div>
                    <div className="col-md-8 offset-md-1">
                        <p>
                            Women who have an idea for a startup, but don't have the time, money, or energy to build it themselves.
                        </p>
                        <ul className="custom-bullets-2">
                            <li>You don't need a business plan or a pitch deck</li>
                            <li>You don't need to have started building anything</li>
                            <li>You don't need to already know your market size</li>
                            <li>You do need to be willing to receive an honest answer</li>
                        </ul>
                        <div className="spacer" />
                        <p>
                            The Nursery is not yet open to investresses seeking to place capital directly —
                            those conversations happen personally.{' '}
                            <Link sx={{ cursor: "pointer" }}
                                onClick={() => window.location.href = `mailto:${'nursery'}@${'startup-doula.com'}`}>
                                Reach out by email
                            </Link> if that's you.
                        </p>
                    </div>
                </div>

                <AnimatedSeparator color="#f52e72" />

                <div className="row">
                    <div className="col-md-8">
                        <h5>Ready to submit your idea?</h5>
                        <p style={{ marginBottom: '2rem' }}>
                            Your idea remains yours — it is protected by a non-disclosure agreement.
                        </p>
                        <Link to="/submit-idea" className="btn-primary">submit your idea</Link>
                    </div>
                </div>

            </div>
        </div>
    );
}
